import React, { useEffect } from 'react';
import { Alert } from './Alert';

export interface ToastProps {
  open: boolean;
  message: string;
  variant: 'success' | 'error' | 'info' | 'warning';
  onClose: () => void;
  duration?: number;
}

export const Toast: React.FC<ToastProps> = ({
  open,
  message,
  variant,
  onClose,
  duration = 6000,
}) => {
  useEffect(() => {
    if (open && duration > 0) {
      const timer = setTimeout(() => {
        onClose();
      }, duration);
      return () => clearTimeout(timer);
    }
  }, [open, onClose, duration]);

  if (!open) return null;

  return (
    <div className="fixed bottom-4 right-4 z-50">
      <Alert variant={variant} onClose={onClose}>
        {message}
      </Alert>
    </div>
  );
};

export default Toast;
